import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-service-definition',
  templateUrl: './service-definition.component.html',
  styleUrls: ['./service-definition.component.css']
})
export class ServiceDefinitionComponent implements OnInit {

  data: any;
  cid:any
  form: any | FormGroup
  viewform: any | FormGroup
  planData: any = [];
  viewPlan:any = []
  serviceKeyValue: any = [];
  formSubmit = false;
  addbutton = true;
  serviceData: any = [];
  isLoading: any = false

  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: any = 0
  tableSizes: any = [3, 6, 9, 12];
  serviceId: any
  singlePlanData: any = []

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
  
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllPlans()
    this.getAllServices()
    this.form = this.fb.group({
      serviceId: ['',[Validators.required]],
      name: ['',[Validators.required]],
      group: ['',[Validators.required]],
      serviceHeading: ['',[Validators.required]],
      serviceSubHeading: ['',[Validators.required]],
      serviceAmount: ['',[Validators.required]],
      // oneTimeCharge: [''],
      // monthlyCharge: [''],
      // usageCharge : [''],
      isPubliclyVisible: false,
      chargeDetail: this.fb.array([]),
      taxPercentage: ['0'],
      taxIncluded: false,
      addonPlan: false,
      planInfoType: ['PREPAID']
    })
    this.addChargeDetail()
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  get chargeDetail(){
    return this.form.get('chargeDetail') as FormArray;
  }
  
  chargeDetailObj(){
    return this.fb.group({
      chargeHeading: [''],
      chargeName: [''],
      chargeAmount: [''],
      chargeType: [''],
    })
  }

 addChargeDetail(){
  this.chargeDetail.push(this.chargeDetailObj())
 }

 removeChargeDetail(index: number){
  this.chargeDetail.removeAt(index)
 }
 
  get ValueArr(){
    return this.form.get('value') as FormArray;
  }
  
 Value(){
  return this.fb.group({
    "value": ['']
  })
 }

 removeInfoObject(index: number){
  this.ValueArr.removeAt(index)
 }

 addPlan(){
  let serviceKeyValue:any = []
  let integrationKeyValue:any = []
  console.log(this.prod)
  for(let i = 0; i < this.prod.length; i++){
    let arr = []
    if(this.prod[i].key != ''){
      for(let j = 0; j < this.prod[i].value.length; j++){
        arr.push(this.prod[i].value[j].value)
      }
      let body = {
        "key": String(this.prod[i].key),
        "value": arr
      }
      serviceKeyValue.push(body)
    }
  }
  for(let i = 0; i < this.integrationKeyValue.length; i++){
    let arr = []
    if(this.integrationKeyValue[i].key != ''){
      for(let j = 0; j < this.integrationKeyValue[i].value.length; j++){
        arr.push(this.integrationKeyValue[i].value[j].value)
      }
      let body = {
        "key": String(this.integrationKeyValue[i].key),
        "value": arr
      }
      integrationKeyValue.push(body)
    }
  }
  let chargeDetail:any = []
  let chargeDetailArr:any = this.form.get('chargeDetail').value
  for(let i = 0; i < chargeDetailArr.length; i++){
    if(chargeDetailArr[i].chargeHeading != '' || chargeDetailArr[i].chargeName != '' || chargeDetailArr[i].chargeAmount != '' || chargeDetailArr[i].chargeType != ''){
      let arr =   {
        "chargeHeading": String(chargeDetailArr[i].chargeHeading),
        "chargeName": String(chargeDetailArr[i].chargeName),
        "chargeAmount": Number(chargeDetailArr[i].chargeAmount),
        "chargeType": String(chargeDetailArr[i].chargeType),
      }
      chargeDetail.push(arr)
    }
  }

  this.formSubmit = true;
  if(!this.form.valid || serviceKeyValue.length == 0 || chargeDetail.length == 0) {
    console.log(this.form.value)
    if(chargeDetail.length == 0 && serviceKeyValue.length == 0) {
      this.toastr.error('atleast one plan and one charge must be specified')
    }
    if(chargeDetail.length == 0 && serviceKeyValue.length != 0) {
      this.toastr.error('atleast one charge must be specified')
    }
    if(chargeDetail.length != 0 && serviceKeyValue.length == 0) {
      this.toastr.error('atleast one plan must be specified')
    }
    return
  }
  this.addbutton = false;

  let body1 = {
    "version": 0,
    "isActive": true,
    "description": "",
    // "id": 0,
    "serviceId": Number(this.form.get('serviceId').value),
    "name": String(this.form.get('name').value),
    "group": String(this.form.get('group').value),
    "planImageUrl": "",
    "planHeading": String(this.form.get('serviceHeading').value),
    "planSubHeading": String(this.form.get('serviceSubHeading').value),
    "planAmount": Number(this.form.get('serviceAmount').value),
    // "oneTimeCharge": Number(this.form.get('oneTimeCharge').value),
    // "monthlyCharge": Number(this.form.get('monthlyCharge').value),
    // "usageCharge": Number(this.form.get('usageCharge').value),
    "chargeDetail": chargeDetail,
    "planKeyValue": serviceKeyValue,
    "integrationKeyValue": integrationKeyValue,
    "isPubliclyVisible": Boolean(this.form.get('isPubliclyVisible').value),
    "addonPlan": Boolean(this.form.get('addonPlan').value),
    "taxIncluded": Boolean(this.form.get('taxIncluded').value),
    "taxPercentage": Number(this.form.get('taxPercentage').value),
    "planInfoType": String(this.form.get('planInfoType').value),
    "cid": Number(this.cid)
  }

  console.log(body1)
  this.generic_service.addPlan(body1).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllPlans()
      this.toastr.success(response.message);
      this.cancelModel()
      this.form.reset()
      this.formSubmit = false;
      this.addbutton = true;
    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
      this.formSubmit = false;
    },
  )
}

cancelModel(){
  document.getElementById("closeModalButton")?.click()
  document.getElementById("closeModalButton1")?.click()
  this.form.reset()
  this.formSubmit = false;
  this.addbutton = true;
}

getAllServices(){
  this.generic_service.getAllServices().subscribe(
    (response:any)=>{
      this.serviceData = response.response;
      console.log(response)
    }
  )
}

getAllPlans(){
  this.isLoading = true
  this.generic_service.getAllPlans().subscribe(
    (response:any)=>{
      this.planData = response.response;
      this.count = response.response.length;
      console.log(response)
      this.isLoading = false
    }
  )
}



getPlanById(id:any){
  this.generic_service.getPlanById(id).subscribe(
    (response:any)=>{
      console.log(response)
      console.log(response.response)
      this.viewPlan = []
      this.viewPlan.push(response.response);
      console.log(this.viewPlan)
      this.serviceKeyValue = []
      this.serviceKeyValue = response.response.planKeyValue
      console.log(this.serviceKeyValue)

      this.singlePlanData = {
        "version": Number(response.response.version),
        "isActive": Boolean(response.response.version),
        "description": String(response.response.description),
        "id": String(response.response.id),
        "planInfoId": Number(response.response.planInfoId),
        "serviceId": Number(response.response.serviceId),
        "name": String(response.response.name),
        "group": String(response.response.group),
        "planImageUrl": String(response.response.planImageUrl),
        "planHeading": String(response.response.planHeading),
        "planSubHeading": String(response.response.planSubHeading),
        "planAmount": Number(response.response.planAmount),
        "oneTimeCharge": Number(response.response.oneTimeCharge),
        "monthlyCharge": Number(response.response.monthlyCharge),
        "usageCharge": Number(response.response.usageCharge),
        "chargeDetail": response.response.chargeDetail,
        "planKeyValue": response.response.planKeyValue,
        "integrationKeyValue": response.response.integrationKeyValue,
        "isPubliclyVisible": Boolean(response.response.isPubliclyVisible),
        "addonPlan": Boolean(response.response.addonPlan),
        "taxIncluded": Boolean(response.response.taxIncluded),
        "taxPercentage": Number(response.response.taxPercentage),
        "taxPrice": Number(response.response.taxPrice),
        "planInfoType": String(response.response.planInfoType),
        "cid": Number(response.response.cid)
      }
    },
    (error)=>{
      console.log(error)
      this.viewPlan = []
      this.serviceKeyValue = []
    }
  )
}


integrationKeyValue = [
  {
    "key": "",
    "value": [
      {
        "value": ""
      }
    ]
  }
]

addvintegration(){
  this.integrationKeyValue.push(
    {
      "key": "",
      "value": [
        {
          "value": ""
        }
      ]
    }
  )
  console.log(this.integrationKeyValue)

}

addintegration(i: any){
  this.integrationKeyValue[i].value.push(  {
    "value": ""
  })
  console.log(this.integrationKeyValue)
}

removeintegration(i:any){
  console.log(i)
  this.integrationKeyValue.splice(i,1)
  console.log(this.integrationKeyValue)
}

removevintegration(i:any,j:any){
  console.log(i)
  console.log(j)
  this.integrationKeyValue[i].value.splice(j,1)
  // this.prod[i].quantity = this.prod[i].infoObj.length

  console.log(this.integrationKeyValue)
}



prod = [
  {
    "key": "",
    "value": [
      {
        "value": ""
      }
    ]
  }
]

addP(){
  this.prod.push(
    {
      "key": "",
      "value": [
        {
          "value": ""
        }
      ]
    }
  )
  console.log(this.prod)

}

addi(i: any){
  this.prod[i].value.push(  {
    "value": ""
  })
  console.log(this.prod)
}

removeProd(i:any){
  console.log(i)
  this.prod.splice(i,1)
  console.log(this.prod)
}

removeValue(i:any,j:any){
  console.log(i)
  console.log(j)
  this.prod[i].value.splice(j,1)
  // this.prod[i].quantity = this.prod[i].infoObj.length

  console.log(this.prod)
}


del(id:any){
  this.serviceId = id;
}


deleteService(){
  this.generic_service.deletePlan(this.serviceId).subscribe(
    (response:any)=>{
      console.log(response);
      this.getAllServices()
      this.getAllPlans()
      this.toastr.success("Successfully Deleted")
      this.cancelModel()
    },
    (error:any)=>{
      console.log(error)
    }
  )
}

updatePlan(){
  let body = {
    "version": Number(this.singlePlanData.version),
    "isActive": Boolean(this.singlePlanData.version),
    "description": String(this.singlePlanData.description),
    "id": String(this.singlePlanData.id),
    "planInfoId": Number(this.singlePlanData.planInfoId),
    "serviceId": Number(this.singlePlanData.serviceId),
    "name": String(this.singlePlanData.name),
    "group": String(this.singlePlanData.group),
    "planImageUrl": String(this.singlePlanData.planImageUrl),
    "planHeading": String(this.singlePlanData.planHeading),
    "planSubHeading": String(this.singlePlanData.planSubHeading),
    "planAmount": Number(this.singlePlanData.planAmount),
    "oneTimeCharge": Number(this.singlePlanData.oneTimeCharge),
    "monthlyCharge": Number(this.singlePlanData.monthlyCharge),
    "usageCharge": Number(this.singlePlanData.usageCharge),
    "chargeDetail": this.singlePlanData.chargeDetail,
    "planKeyValue": this.singlePlanData.planKeyValue,
    "integrationKeyValue": this.singlePlanData.integrationKeyValue,
    "isPubliclyVisible": Boolean(this.singlePlanData.isPubliclyVisible),
    "addonPlan": Boolean(this.singlePlanData.addonPlan),
    "taxIncluded": Boolean(this.singlePlanData.taxIncluded),
    "taxPercentage": Number(this.singlePlanData.taxPercentage),
    "taxPrice": Number(this.singlePlanData.taxPrice),
    "planInfoType": String(this.singlePlanData.planInfoType),
    "cid": Number(this.singlePlanData.cid)
  }

  console.log(this.singlePlanData)
  this.generic_service.updatePlan(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllServices()
      this.getAllPlans()

      document.getElementById("closeModalButton3")?.click()
      this.toastr.success("Successfully Updated");  
    },
    (err:any)=>{
      console.log(err)
      this.toastr.error(err.error.errors[0].description);
    },
  )
 }

}